export default function ThankYou() {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-[#1A1A1A] text-[#E5E7EB] px-6">
      <h1 className="text-4xl font-bold text-[#D4AF37] mb-6">
        Thank You 🤲
      </h1>

      <p className="text-[#A1A1AA] text-lg text-center max-w-xl">
        JazakAllah Khair for registering as a Sehri Provider.
        Our team will verify your details and publish them soon.
      </p>
    </div>
  );
}
